export default["__VITE_ASSET__k9hG6k_C__","__VITE_ASSET__KfAtYFG6__"];